import { action, observable } from 'mobx'
import { SalaryVpRequest } from '../requests/SalaryVpRequest'

class SalaryVpStore {
  // Page list salary VP (Duyệt lương)
  @observable salaryVpListPage = []
  @observable salaryVpListPageTotal = 0
  @observable salaryVpQueryParam = {
    page: 0,
    size: 10,
  }

  @action setSalaryVpQueryParam = payload => {
    this.salaryVpQueryParam = { ...this.salaryVpQueryParam, ...payload }
  }

  @action getSalaryVpList = () => {
    return new Promise((resolve, reject) => {
      SalaryVpRequest.getSalaryList(this.salaryVpQueryParam)
        .then(response => {
          this.salaryVpListPage = response.data.data || []
          this.salaryVpListPageTotal = response.data.total_count
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action clearSalaryVpListPage = () => {
    this.salaryVpListPage = []
    this.salaryVpQueryParam = {
      page: 0,
      size: 10,
    }
    this.salaryVpListPageTotal = 0
  }

  // Create + detail salary VP
  @observable salaryVpDetails = []
  @observable salaryVpInfo = {}
  @observable actionHistory = []
  @observable isShowSalaryVpInfo = false

  @action setIsShowSalaryVpInfo = bool => {
    this.isShowSalaryVpInfo = bool
  }

  @action importSalaryVpFile = formData => {
    return new Promise((resolve, reject) => {
      SalaryVpRequest.importSalaryFile(formData)
        .then(response => {
          this.salaryVpDetails = response.data.salary_details || []
          this.salaryVpInfo = {
            file_id: response.data.file_id,
            file_name: response.data.file_name,
            from_file_code: response.data.from_file_code,
            total_employees: response.data.total_employees
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action createSalaryVp = payload => {
    return new Promise((resolve, reject) => {
      SalaryVpRequest.createSalary(payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action deleteSalaryVp = salaryCode => {
    return new Promise((resolve, reject) => {
      SalaryVpRequest.deleteSalary(salaryCode)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getSalaryVpDetail = salaryCode => {
    return new Promise((resolve, reject) => {
      SalaryVpRequest.getSalaryDetail(salaryCode)
        .then(response => {
          this.salaryVpDetails = response.data.salary_details || []
          this.actionHistory = response.data.action_history || []
          this.salaryVpInfo = {
            code: response.data.code,
            title: response.data.title,
            salary_month: response.data.salary_month,
            status: response.data.status,
            created_date: response.data.created_date,
            created_user: response.data.created_user
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action approveSalaryVp = salaryCode => {
    return new Promise((resolve, reject) => {
      SalaryVpRequest.approveSalary(salaryCode)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action clearSalaryVpDetail = () => {
    this.salaryVpDetails = []
    this.salaryVpInfo = {}
    this.actionHistory = []
    this.isShowSalaryVpInfo = false
  }

  // My Salary VP (Lương của tôi)
  @observable mySalaryVpList = []
  @observable mySalaryVpTotal = 0
  @observable mySalaryVpQuery = {
    page: 0,
    size: 10
  }

  @action setMySalaryVpQuery = payload => {
    this.mySalaryVpQuery = { ...this.mySalaryVpQuery, ...payload }
  }

  @action getMySalaryVpList = () => {
    return new Promise((resolve, reject) => {
      SalaryVpRequest.getMySalaryList(this.mySalaryVpQuery)
        .then(response => {
          this.mySalaryVpList = response.data.data || []
          this.mySalaryVpTotal = response.data.total_count
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action clearMySalaryVpList = () => {
    this.mySalaryVpList = []
    this.mySalaryVpTotal = 0
    this.mySalaryVpQuery = {
      page: 0,
      size: 10
    }
  }
}

export default new SalaryVpStore()
